module.exports = __webpack_public_path__ + "media/images/athletes/2829-ad157357e7362c30c6fccb9c514d35f3.png";